<!-- eslint-disable no-unused-expressions -->
<!-- eslint-disable no-undef -->
<!-- eslint-disable no-restricted-syntax -->
<!-- eslint-disable quotes -->
<!-- eslint-disable vue/no-parsing-error -->
<!-- eslint-disable vue/max-attributes-per-line -->
<!-- eslint-disable vue/valid-v-for -->
<!-- eslint-disable vue/html-indent -->
<template>
    <div>

        <b-card no-body>
            <b-card-header class="pb-50">
                <h5>Society Details</h5>
            </b-card-header>
            <b-card-body>
                <b-row>

                    <!-- User Info: Left col -->
                    <b-col cols="21" xl="6" class="d-flex justify-content-between flex-column">
                        <!-- User Avatar & Action Buttons -->
                        <div class="d-flex justify-content-start">
                            <b-avatar src="assets/images/avatars/society.png" size="130px" rounded />
                            <div class="d-flex flex-column ml-1">
                                <div class="mb-1" v-if="society">
                                    <h5 class="mb-0">Name : {{ society.name }}</h5>
                                    <h5 class="mb-0">Code : {{ society.code }}</h5>
                                </div>
                                <!-- User Stats -->
                                <div class="d-flex align-items-center mt-2">
                                    <div class="d-flex align-items-center mr-2">
                                        <b-avatar variant="light-primary" rounded>
                                            <feather-icon icon="UserIcon" size="18" />
                                        </b-avatar>
                                        <div class="ml-1" v-if="society">
                                            <h5 class="mb-0 text-center">
                                                {{ society.growers_count ? society.growers_count : 0 }}
                                            </h5>
                                            <small>Farmers</small>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div class="d-flex flex-wrap align-items-center mt-2" v-if="accountsByCurrency">
                            <div class="d-flex align-items-center mr-2"
                                v-for="(accounts, currency) in accountsByCurrency" :key="currency">
                                <b-avatar variant="light-primary" rounded>
                                    <feather-icon icon="CreditCardIcon" size="18" />
                                </b-avatar>
                                <div class="ml-1">
                                    <h6 class="mb-0 text-center">{{ accounts[0].bank.name }} <small>({{ accounts[0].bank.abbreviation }})</small></h6>
                                    <h5 class="mb-0">{{ accounts[0].number }}</h5>
                                    <small>{{ currency }} Account</small>
                                </div>
                            </div>
                        </div>


                        <!-- <pre>
                            {{ loan }}
                        </pre> -->
                    </b-col>


                    <!-- Right Col: Table -->
                    <b-col cols="12" xl="6">
                        <validation-observer ref="dataForm" #default="{ invalid }">
                            <b-form ref="form" @submit.stop.prevent="handleSubmit">
                                <!-- Row 1: Name and Is Optional -->
                                <b-row>
                                    <b-col cols="6">
                                        <b-form-group label-for="number" label="Serial #">
                                            <validation-provider v-slot="{ errors, valid }" name="number">
                                                <b-form-input type="text" id="number" name="number"
                                                    v-model="loan.number" size="sm" />
                                                <small class="text-danger">{{ errors[0] }}</small>
                                                <small v-if="serverErrors && serverErrors.number" class="text-danger">{{
                                                    serverErrors.number[0] }}</small>
                                            </validation-provider>
                                        </b-form-group>
                                    </b-col>

                                    <b-col cols="6">
                                        <b-form-group label-for="dateTaken" label="Date Taken">
                                            <validation-provider v-slot="{ errors, valid }" name="dateTaken">
                                                <b-form-datepicker id="dateTaken" name="dateTaken"
                                                    v-model="loan.dateTaken" :state="errors.length > 0 ? false : null"
                                                    size="sm"
                                                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                                    locale="en" :max="new Date().toISOString().split('T')[0]" />
                                                <small class="text-danger">{{ errors[0] }}</small>
                                                <small v-if="serverErrors && serverErrors.dateTaken"
                                                    class="text-danger">{{ serverErrors.dateTaken[0] }}</small>
                                            </validation-provider>
                                        </b-form-group>
                                    </b-col>
                                </b-row>

                                <!-- Row 2: Description -->
                                <b-row>
                                    <b-col cols="12">
                                        <b-form-group label="Description" label-for="description">
                                            <validation-provider v-slot="{ errors, valid }" name="description">
                                                <b-form-textarea id="description" v-model="loan.description"
                                                    name="description" rows="3" size="sm" />
                                                <small class="text-danger">{{ errors[0] }}</small>
                                            </validation-provider>
                                        </b-form-group>
                                    </b-col>
                                </b-row>

                                <!-- Row 3: Package Type and Account Number -->
                                <b-row>
                                    <b-col cols="6">
                                        <b-form-group label-for="package_id" label="Package Type">
                                            <validation-provider v-slot="{ errors, valid }" name="package_id">
                                                <b-form-select size="sm" v-model="loan.package_id">
                                                    <b-form-select-option :value="null">-- Select
                                                        --</b-form-select-option>
                                                    <b-form-select-option v-for="pack in packages" :key="pack.id"
                                                        :value="pack.id">
                                                        {{ pack.name }}
                                                    </b-form-select-option>
                                                </b-form-select>
                                                <small class="text-danger">{{ errors[0] }}</small>
                                            </validation-provider>
                                        </b-form-group>
                                    </b-col>

                                    <b-col cols="6">
                                        <b-form-group label-for="account_id" label="Which Account Number?">
                                            <validation-provider v-slot="{ errors, valid }" name="account_id">
                                                <div v-if="society && society.accounts && society.accounts.length > 0">
                                                    <b-form-select size="sm" v-model="loan.account_id">
                                                        <b-form-select-option :value="null">-- Select
                                                            --</b-form-select-option>
                                                        <b-form-select-option v-for="acc in society.accounts"
                                                            :key="acc.id" :value="acc.id">
                                                            {{ acc.number }} ({{ acc.currency.abbreviation }})
                                                        </b-form-select-option>
                                                    </b-form-select>
                                                    <small class="text-danger">{{ errors[0] }}</small>
                                                </div>
                                                <div v-else-if="society && society.accounts && society.accounts.length === 0"
                                                    class="text-danger">
                                                    No accounts available.
                                                </div>
                                                <div v-else class="text-muted">
                                                    Loading accounts...
                                                </div>
                                            </validation-provider>
                                        </b-form-group>
                                    </b-col>
                                </b-row>

                                <!-- Row 4: Amount and Submit button -->
                                <b-row>
                                    <b-col cols="6">
                                        <b-form-group label="Amount" label-for="amount">
                                            <validation-provider v-slot="{ errors, valid }" name="amount">
                                                <b-form-input id="amount" v-model="loan.amount" name="amount"
                                                    type="number" size="sm" />
                                                <small class="text-danger">{{ errors[0] }}</small>
                                            </validation-provider>
                                        </b-form-group>
                                    </b-col>

                                    <b-col cols="6">
                                        <b-button class="mt-2" size="sm" variant="primary"
                                            :disabled="!isFormValid || saving" @click="handleSubmit()">
                                            <b-spinner v-if="saving" small class="mr-1" label="Small Spinner" />
                                            <span v-if="!saving">Save</span>
                                            <span v-if="saving">Saving...</span>
                                        </b-button>
                                    </b-col>
                                </b-row>
                            </b-form>


                        </validation-observer>
                    </b-col>

                </b-row>
                <hr>
                <!-- <pre>{{ loan }}</pre> -->

            </b-card-body>
        </b-card>

        <!-- Table Container Card -->
        <b-card no-body class="mb-0">
            <div class="m-2">
                <!-- Table Top -->
                <b-row>
                    <!-- Per Page -->
                    <b-col cols="12" md="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
                        <label>Show</label>
                        <v-select v-model="perPage" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :options="perPageOptions" :clearable="false"
                            class="per-page-selector d-inline-block mx-50 select-size-sm" />
                        <label>entries</label>
                    </b-col>
                    <!-- ./Per Page -->

                    <!-- Search -->
                    <b-col cols="12" md="6">
                        <div class="d-flex align-items-center justify-content-end">
                            <b-form-input v-model="searchQuery" class="d-inline-block mr-1" placeholder="Search..."
                                size="sm" />
                        </div>

                    </b-col>
                    <!-- ./Search -->
                </b-row>
                <!-- ./Table Top -->
            </div>

            <!-- Table -->
            <b-table :items="loans" :fields="columns" responsive striped hover small show-empty
                empty-text="No loans available" primary-key="id">
                <!-- Package Name -->
                <template #cell(package)="data">
                    <span class="text-nowrap font-weight-bold">
                        {{ data.item.package.name }}
                    </span>
                </template>

                <!-- Amount from first transaction -->
                <template #cell(amount)="data">
                    <span class="text-nowrap">
                        {{ formatCurrency(getAmountByCurrency(data.item)) }}
                    </span>
                </template>

                <!-- Actions -->
                <template #cell(actions)="data">
                    <b-dropdown variant="link" no-caret>
                        <template #button-content>
                            <feather-icon icon="MoreVerticalIcon" size="16" />
                        </template>
                        <b-dropdown-item @click="viewLoan(data.item)">View</b-dropdown-item>
                        <b-dropdown-item @click="editLoan(data.item)">Edit</b-dropdown-item>
                    </b-dropdown>
                </template>
            </b-table>





        </b-card>
        <!-- ./Table Container Card -->

    </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { ref, onUnmounted, onMounted, computed } from '@vue/composition-api'
import store from '@/store'
import societiesLoanStoreModule from '@/views/cromis/society/societiesLoanStoreModule'
import useSocietiesLoanList from '@/views/cromis/society/useSocietiesLoanList'
import vSelect from 'vue-select'
import {
    BCard, BCardHeader, BCardBody, BRow, BCol, BForm, BFormGroup, BFormInput, BFormCheckbox, BFormSelect, BFormSelectOption, BModal, VBModal, BButton, BTable,
    BBadge, BDropdown, BDropdownItem, BPagination, BSpinner, BAvatar, BFormDatepicker, BFormTextarea, FormSelect,
} from 'bootstrap-vue'


export default {
    components: {
        BCard,
        BCardHeader,
        BCardBody,
        BRow,
        BCol,
        BForm,
        BFormGroup,
        BFormInput,
        BFormCheckbox,
        BFormSelect,
        BFormSelectOption,
        BModal,
        BButton,
        BSpinner,
        BTable,
        BBadge,
        BDropdown,
        BDropdownItem,
        BPagination,
        BAvatar,
        BFormDatepicker,
        BFormTextarea, vSelect,

        ValidationProvider,
        ValidationObserver,
    },
    directives: {},
    props: {
    },

    setup(props, context) {
        const { id } = context.root.$router.currentRoute.params
        const serverErrors = ref(null)
        const dataForm = ref(null)
        const selections = ref([])
        const formSelections = ref([])
        const society = ref(null)
        const packages = ref([])
        const saving = ref(false)
        const loans = ref(null)
        const loan = ref({
            id: null,
            dateTaken: null,
            number: null,
            description: null,
            amount: null,
            package_id: null,
            account_id: null,
            debtor_id: null,
            type: 1,
        })

        const columns = [
            { key: 'number', label: 'Loan No' },
            { key: 'dateTaken', label: 'Date Taken' },
            { key: 'description', label: 'Description' },
            { key: 'package', label: 'Package' },
            { key: 'amount', label: 'Amount' },
            { key: 'actions', label: '', class: 'text-center' },
        ]
        const CROMIS_SOCIETY_STORE_MODULE_NAME = 'cromis-loan'

        // Register module
        if (!store.hasModule(CROMIS_SOCIETY_STORE_MODULE_NAME)) store.registerModule(CROMIS_SOCIETY_STORE_MODULE_NAME, societiesLoanStoreModule)

        // UnRegister on leave
        onUnmounted(() => {
            if (store.hasModule(CROMIS_SOCIETY_STORE_MODULE_NAME)) store.unregisterModule(CROMIS_SOCIETY_STORE_MODULE_NAME)
        })

        onMounted(async () => {
            console.log(id)
            try {
                await store.dispatch('cromis-loan/show', { id: id })
                    .then(response => {
                        loans.value = response.data.loans
                        society.value = response.data
                    })
                    .catch(error => {
                        console.log('got error', error)
                    })
            } catch (error) {
                console.error(error)
            }

            loan.value = {
                id: null,
                dateTaken: null,
                number: null,
                description: null,
                amount: null,
                package_id: null,
                account_id: null,
                debtor_id: society.value.id,
                type: 1,
            }

            try {
                await store.dispatch('cromis-loan/packages')
                    .then(response => {
                        packages.value = response.data.packages
                        console.log(packages.value)
                    })
                    .catch(error => {
                        console.log('got error', error)
                    })
            } catch (error) {
                console.error(error)
            }


        })


        const getAmount = (loan) => {
            if (loan.transactions && loan.transactions.length > 0) {
                return loan.transactions.reduce((sum, tx) => {
                    return tx.sign === '+' ? sum + tx.amount : sum - tx.amount
                }, 0)
            }
            return 0
        }

        // Format the amount with currency symbol
        const formatAmount = (amount, symbol = 'Tsh') => {
            return `${symbol} ${amount.toLocaleString(undefined, { minimumFractionDigits: 0 })}`;
        }

        // Format the amount based on the loan's currency
        const formatCurrency = (totals) => {
            let formattedCurrency = ''
            // eslint-disable-next-line guard-for-in, no-restricted-syntax
            for (const currency in totals) {
                formattedCurrency += `${currency}: ${formatAmount(totals[currency].total, totals[currency].symbol)} `
            }
            return formattedCurrency.trim();
        }

        const getAmountByCurrency = (loan) => {
            const totals = {}

            if (loan.transactions && loan.transactions.length > 0) {
                loan.transactions.forEach(tx => {
                    const currency = tx.account?.currency?.abbreviation || 'TZS'
                    const symbol = tx.account?.currency?.symbol || 'Tsh'

                    if (!totals[currency]) {
                        totals[currency] = {
                            symbol,
                            total: 0
                        }
                    }

                    const amount = tx.sign === '+' ? tx.amount : -tx.amount
                    totals[currency].total += amount
                })
            }

            return totals
        }


        const viewLoan = (loan) => {
            localStorage.setItem('selectedLoan', JSON.stringify(loan))
            // Redirect or open modal logic here if needed
            console.log('Viewing loan:', loan)
        }

        const editLoan = (loan) => {
            localStorage.setItem('editLoan', JSON.stringify(loan))
            // Redirect or open form logic here if needed
            console.log('Editing loan:', loan)
        }


        const accountsByCurrency = computed(() => {
            const grouped = {}
            if (society.value && society.value.accounts) {
                // eslint-disable-next-line no-restricted-syntax
                for (const acc of society.value.accounts) {
                    const currency = acc.currency?.abbreviation || 'UNKNOWN'
                    if (!grouped[currency]) {
                        grouped[currency] = []
                    }
                    grouped[currency].push(acc)
                }
            }
            console.log(grouped)
            return grouped
        })
        const isFormValid = async () => {
            let isValid = false
            await dataForm.value.validate().then(success => {
                isValid = success
            })

            return isValid
        }

        const handleSubmit = async () => {
            saving.value = true
            const valid = await isFormValid()

            if (
                !loan.value.amount ||
                !loan.value.dateTaken ||
                !loan.value.description ||
                !loan.value.number
            ) {
                saving.value = false

                context.root.$swal({
                    icon: 'error',
                    text: 'Please fill in all required fields before submitting.',
                    showConfirmButton: true,
                    customClass: {
                        confirmButton: 'btn btn-danger',
                    },
                    buttonsStyling: false,
                })

                return
            }


            console.log('Submitting:', loan.value)

            await store.dispatch('cromis-loan/update', { id: loan.value.debtor_id, data: loan.value })
                .then(async response => {
                    saving.value = false

                    context.root.$swal({
                        icon: 'success',
                        text: 'Changes to society successfully!',
                        showConfirmButton: true,
                        timer: 5000,
                        customClass: {
                            confirmButton: 'btn btn-success',
                        },
                        buttonsStyling: false,
                    })
                    loan.value.account_id = null,
                        loan.value.amount = null,
                        loan.value.dateTaken = null,
                        loan.value.description = null,
                        loan.value.number = null,
                        loan.value.package_id = null

                    try {
                        await store.dispatch('cromis-loan/show', { id: id })
                            .then(response => {
                                loans.value = response.data.loans
                                society.value = response.data
                            })
                            .catch(error => {
                                console.log('got error', error)
                            })
                    } catch (error) {
                        console.error(error)
                    }
                })
                .catch(error => {
                    saving.value = false

                    context.root.$swal({
                        icon: 'error',
                        title: 'Server Error',
                        text: 'Something went wrong. See tech support',
                        showConfirmButton: true,
                        customClass: {
                            confirmButton: 'btn btn-danger',
                        },
                        buttonsStyling: false,
                    })
                })
        }

        // eslint-disable-next-line no-empty-pattern
        const {
            fetch,
            perPage,
            currentPage,
            // totalRecords,
            // from,
            // to,
            meta,
            perPageOptions,
            searchQuery,
            sortBy,
            isSortDirDesc,
            records,
            refetch,

            // Filers
            locationFilter,
        } = useSocietiesLoanList()

        return {
            id,
            loan,
            loans,
            selections,
            formSelections,
            society,
            saving,
            packages,


            fetch,
            columns,
            perPage,
            currentPage,
            // totalRecords,
            // from,
            // to,
            meta,
            perPageOptions,
            searchQuery,
            sortBy,
            isSortDirDesc,
            records,
            refetch,
            locationFilter,
            serverErrors,

            isFormValid,
            dataForm,
            handleSubmit,

            // helper functions
            editLoan,
            viewLoan,
            formatCurrency,
            getAmount,
            getAmountByCurrency,
            formatAmount,

            accountsByCurrency,
        }
    },
}
</script>

<style lang="scss" scoped></style>
